module.exports = __webpack_public_path__ + "73ffb9b746e69be5a94b81e138cc10d6.pdf";